const isMultiLevel = opts => opts.some(_ref => {
  let {
    children
  } = _ref;
  return children && children.length;
});
export default isMultiLevel;
//# sourceMappingURL=isMultiLevel.js.map